// extracted by mini-css-extract-plugin
export default {"wrapper":"SlackButton_wrapper_HArLx","label":"SlackButton_label_gjlMj","button":"SlackButton_button_r35Vl"};